export default __webpack_public_path__ + "static/media/IMG_0908.476bb675.jpg";